import ReportMutationsTypes from './ReportTemplateMutationTypes';
import ReportService from '../../../../../cmms/reports/service/ReportService';

async function loadTemplates({ commit }) {
  const templates = await ReportService.getTemplates();
  commit(ReportMutationsTypes.UPDATE_TEMPLATES, templates);
}

async function createTemplate({ commit, state }, template) {
  const createdTemplate = await ReportService.saveTemplate(template);
  const templates = [...state.templates, createdTemplate];
  commit(ReportMutationsTypes.UPDATE_TEMPLATES, templates);
}

async function updateTemplate({ commit, state }, template) {
  const updatedTemplate = await ReportService.saveTemplate((template));
  const templates = state.templates.map((existingTemplate) => {
    if (existingTemplate.id !== updatedTemplate.id) {
      return existingTemplate;
    }
    return updatedTemplate;
  });
  commit(ReportMutationsTypes.UPDATE_TEMPLATES, templates);
}

async function removeTemplate({ commit, state }, template) {
  await ReportService.removeTemplate(template.id);

  const templates = state.templates
    .filter((existingTemplate) => existingTemplate.id !== template.id);
  commit(ReportMutationsTypes.UPDATE_TEMPLATES, templates);
}

const ReportTemplateActions = {
  loadTemplates,
  createTemplate,
  updateTemplate,
  removeTemplate,
};

export default ReportTemplateActions;
